import { render } from "./DetailPayment.vue?vue&type=template&id=1c261366&scoped=true&ts=true"
import script from "./DetailPayment.vue?vue&type=script&lang=ts"
export * from "./DetailPayment.vue?vue&type=script&lang=ts"

import "./DetailPayment.vue?vue&type=style&index=0&id=1c261366&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c261366"]])

export default __exports__